module.exports = firebase["database"];